
import { fork, takeLatest } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import workerSaga from './workerSaga';
import { takeLatestUntilApiCancel } from './merchantListing';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* reportWatcher(): Generator<any, void, unknown> {
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_REPORT_FEATURES);
  yield takeLatest(ActionConstants.GET_REPORT_USER_EMAILS, workerSaga);
  yield takeLatest(ActionConstants.GENERATE_INSTANT_REPORTS, workerSaga);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_ALL_REPORT_LIST);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_SCHEDULE_REPORT_LIST);
  yield takeLatest(ActionConstants.GET_MASTER_LIST, workerSaga);
  yield takeLatest(ActionConstants.GET_REPORT_CATEGORY_DETAILS, workerSaga);
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_DOWNLOAD_REPORT);
  yield takeLatest(ActionConstants.CREATE_SCHEDULED_REPORT, workerSaga);
  yield takeLatest(ActionConstants.PAUSE_SCHEDULED_REPORT, workerSaga);
  yield takeLatest(ActionConstants.RESUME_SCHEDULED_REPORT, workerSaga);
  yield takeLatest(ActionConstants.UPDATE_SCHEDULED_REPORT, workerSaga);
  yield takeLatest(ActionConstants.DELETE_SCHEDULED_REPORT, workerSaga);
}

